"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.postPublicEmail = void 0;
/**
 * Send a templated email from a list of allowed templated id's.
`body` content will change based on the [template](https://account.postmarkapp.com/servers/5492883/templates) id used.
`body` properties can be one of:
__[key: string]: string | { [key: string]: string } } | { [key: string]: string }[]__

 */
var postPublicEmail = function (instance) {
    return function (body, config) {
        return instance.post("/emails/public", body, config);
    };
};
exports.postPublicEmail = postPublicEmail;
